import { FileRepoFilters } from "store/types";

export const defaultFileFilters: FileRepoFilters = {
  deals: [],
  investors: [],
  document_types: [],
  source: [],
  file_types: [],
  date: null,
  show_latest: false
};

export const fileExtensions = [
  "jpg",
  "png",
  "csv",
  "xls",
  "ppt",
  "pptx",
  "pdf",
  "doc",
  "docx",
  "xlsx",
  "txt",
  "xlsb",
  "xltx",
  "xltm",
  "xlt",
  "xlm",
  "gif",
  "jpeg",
  "bmp",
  "tiff",
  "tif"
];
